import React from "react";
import Card from "@/components/Card";
import { Box, Typography } from "@mui/material";
import { StyledSwitch } from "@/components/styled";
import { useApplicationStore } from "@/store/applicationStore.ts";

const AllowDocumentUploadsToggle = () => {
  const allowDocumentUploads = useApplicationStore(
    (state) => state.allowDocumentUploads,
  );
  const toggleAllowDocumentUploads = useApplicationStore(
    (state) => state.toggleAllowDocumentUploads,
  );

  const toggleLabel = allowDocumentUploads
    ? "Document Uploads Enabled"
    : "Document Uploads Disabled";
  return (
    <Card sx={{ marginBottom: "20px" }} title={""}>
      <Box sx={{ display: "flex", gap: "8px" }}>
        <StyledSwitch
          variant={"first"}
          checked={!!allowDocumentUploads}
          onChange={toggleAllowDocumentUploads}
        />
        <Typography variant={"helperText"} style={{ fontSize: "16px" }}>
          {toggleLabel}
        </Typography>
      </Box>
    </Card>
  );
};

export default AllowDocumentUploadsToggle;
